import React from 'react';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo - Enhanced visibility */}
      <div className="flex items-center justify-center mb-8">
        <div className="relative">
          <img
            src="/assets/images/aletheos_MD_vertical_navy-1758752254158.png"
            alt="Aletheos MD Logo"
            className="w-40 h-auto md:w-48 lg:w-56 transition-transform duration-300 hover:scale-105 drop-shadow-sm"
          />
          {/* Subtle glow effect for enhanced visibility */}
          <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent rounded-lg -z-10 blur-xl"></div>
        </div>
      </div>
      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-2xl lg:text-3xl font-heading font-bold text-foreground">
          Truth. Word. Power.
        </h1>
        <p className="text-muted-foreground text-base lg:text-lg">
          Sign in to embrace truth, refine reason, and move forward with strength.
        </p>
      </div>
      {/* Current Date Display */}
      <div className="mt-4 px-4 py-2 bg-muted rounded-lg inline-block">
        <p className="text-sm text-muted-foreground">
          Today is {new Date()?.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;